import {
  CustomerStatisticsAction,
  CustomerStatisticsActions
} from './../model';

export const fetchStatisticsStock = ({
  customerId,
  articleIds,
  year,
  month,
  unitCount = 6,
}: {
  customerId: string;
  articleIds?: number[];
  year?: number;
  month?: number;
  unitCount?: number;
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.FETCH_STATISTICS_STOCK,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/statistics`,
      method: 'GET',
      params: {
        articleIds: ((articleIds?.length ?? 0) > 0) ? JSON.stringify(articleIds) : 'all',
        unitCount: (!year && !month) ? unitCount : undefined,
        unit: (!year && !month) && (unitCount > 1) ? 'month' : 'day',
        year,
        month,
      },
    },
  },
});

export const fetchStatisticsOrders = ({
  customerId,
  articleIds,
}: {
  customerId: string;
  articleIds?: number[];
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.FETCH_STATISTICS_ORDERS,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/orders`,
      method: 'GET',
      params: {
        articleIds,
      },
    },
  },
});

export const fetchStatisticsShipments = ({
  customerId,
  articleIds,
}: {
  customerId: string;
  articleIds?: number[];
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.FETCH_STATISTICS_SHIPMENTS,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/shipments`,
      method: 'GET',
      params: {
        articleIds,
      },
    },
  },
});

export const fulfillStatisticsOrder = ({
  customerId,
  orderId,
}: {
  customerId: string;
  orderId: number;
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.FULFILL_STATISTICS_ORDER,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/orders/${orderId}/fulfill`,
      method: 'PUT',
    },
  },
});

export const confirmStatisticsShipment = ({
  customerId,
  shipmentId,
}: {
  customerId: string;
  shipmentId: number;
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.CONFIRM_STATISTICS_SHIPMENT,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/events/${shipmentId}/confirm`,
      method: 'PATCH',
    },
  },
});

export const confirmCustomArticleArrival = ({
  customerId,
  eventId,
  amount,
}: {
  customerId: string;
  eventId: number;
  amount: number;
}): CustomerStatisticsAction => ({
  type: CustomerStatisticsActions.CONFIRM_CUSTOM_ARTICLE_ARRIVAL,
  payload: {
    request: {
      url: `/stock-articles/forcustomer/${customerId}/events/${eventId}/confirm/custom`,
      method: 'PATCH',
      data: { amount },
    },
  },
});
